// Hero.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import heroImage from '../assets/hero-image.png';

const Hero = () => {
  return (
    <motion.section
      className="relative overflow-hidden"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="mx-3 md:mx-10 lg:mx-16 mt-4 md:mt-6 rounded-3xl bg-gradient-to-br from-indigo-700 via-blue-600 to-blue-500">
        <div className="relative overflow-hidden px-6 md:px-12 lg:px-16 pt-32 md:pt-36 pb-0">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-52 -right-60 w-[920px] h-[920px] rounded-full border border-white/10" />
            <div className="absolute -top-40 -right-44 w-[720px] h-[720px] rounded-full border border-white/15" />
            <div className="absolute -top-28 -right-28 w-[520px] h-[520px] rounded-full border border-white/20" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-stretch">
            <div className="text-left pb-14 md:pb-20">
              <motion.h1
                className="md:mt-24 text-4xl md:text-4xl font-inter font-medium text-white leading-[1.05]"
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.15 }}
              >
               Business & Tech
                <br />
                Courses That
                <span className="relative inline-block mx-2">
                  <span className="absolute inset-0 bg-pink-400 rounded-full -rotate-2" />
                  <span className="relative px-3 text-indigo-900">Actually</span>
                </span>
                <br />
                Deliver
                <span className="relative inline-block ml-2">
                  <span className="absolute inset-0 bg-yellow-300 rounded-full -rotate-2" />
                  <span className="relative px-3 text-indigo-900">Results</span>
                </span>
              </motion.h1>

              <motion.p
                className="text-white/80 mt-5 text-base md:text-lg max-w-xl"
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.3 }}
              >
                Curated learning programs across business and tech, hosted on secure platforms.
              </motion.p>

              <motion.div
                className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4"
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.45 }}
              >
                <Link
                  to="/#courses"
                  onClick={() => {
                    window.setTimeout(() => {
                      const el = document.getElementById('courses');
                      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 0);
                  }}
                  className="relative z-10 cursor-pointer px-7 py-3.5 rounded-full bg-white text-acBlack text-sm md:text-base font-inter font-semibold hover:bg-white/90 transition"
                >
                  Browse Courses
                </Link>
                {/* <Link
                  to="/#submit-course"
                  className="text-white/90 hover:text-white text-sm md:text-base font-inter underline underline-offset-4 transition"
                >
                  Submit a Course
                </Link> */}
              </motion.div>

              <motion.div
                className="mt-8 flex flex-wrap items-center gap-3"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.55 }}
              >
                {/* <div className="bg-white/10 border border-white/15 text-white px-4 py-2 rounded-full text-xs md:text-sm font-inter">
                  Verified listings
                </div>
                <div className="bg-white/10 border border-white/15 text-white px-4 py-2 rounded-full text-xs md:text-sm font-inter">
                  Clear outcomes upfront
                </div>
                <div className="bg-white/10 border border-white/15 text-white px-4 py-2 rounded-full text-xs md:text-sm font-inter">
                  No fake gurus
                </div> */}
              </motion.div>
            </div>

            <motion.div
              className="relative flex items-end"
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.25 }}
            >
              <div className="relative mx-auto max-w-md lg:max-w-none">
                <img
                  src={heroImage}
                  alt="Validemy hero"
                  className="w-full max-w-md lg:max-w-lg mx-auto drop-shadow-2xl"
                />

                <div className="absolute bottom-10 left-0 bg-white/95 rounded-2xl px-4 py-3 shadow-lg">
                  <div className="text-xs text-gray-600 font-inter">Business & Tech </div>
                  <div className="text-sm font-semibold text-acBlack font-inter">Business & Tech Courses</div>
                </div>

                <div className="absolute top-10 right-0 bg-white/95 rounded-2xl px-4 py-3 shadow-lg">
                  <div className="text-xs text-gray-600 font-inter">Freedom + opportunity</div>
                  <div className="text-sm font-semibold text-acBlack font-inter">A bigger future with Valicourses</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
